import { Link } from "react-router-dom";
import { auth } from "../Functions/SignUp/Firebse.js";
import React, { useContext, useState, useEffect } from 'react';

const NavBtns = () => {
  const [userDet, setUserDet] = useState(null);

  const fetchData = async () => {
    auth.onAuthStateChanged(async (user) => {
      setUserDet(user);
    });
  };
  
  async function logout() {
    try {
      await auth.signOut();
      window.location.href = "/scoreboard";
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

    return (
        <>

           <nav className=" sidebtns  navbar-expand-md  sticky-top border-bottom" data-bs-theme="dark">
  <div className="container">
    <a className="navbar-brand d-md-none shrink" href="#" style={{color:"white"}}>
      Typeathon
    </a>
    <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvas" aria-controls="offcanvas" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvas" aria-labelledby="offcanvasLabel">
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" style={{color:"white"}} id="offcanvasLabel">Typeathon</h5>
        <button type="button" className="btn-close" style={{backgroundColor:"black"}} data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div className="offcanvas-body">
        <ul className="navbar-nav flex-grow-1 justify-content-between">
          <li className="nav-item"><a className="nav-link" href="#">
          </a></li>
          <li className="nav-item"><Link to="/"> <button>Home</button></Link></li>
          <li className="nav-item"><Link to="/explore"> <button>Explore </button></Link></li>
          <li className="nav-item"> <Link to="/practiceboard"><button>Practice Board</button></Link></li>
          <li className="nav-item"><Link to="/scoreboard"> <button>Scores</button></Link></li>
          {userDet ? (
          <li className="nav-item"> <button onClick={logout}>LogOut</button></li>) :
          (   <li className="nav-item"><Link to="/signupgoogle"><button>LogIn</button></Link></li>)}
          <li className="nav-item"><a className="nav-link" href="#">
          </a></li>
        </ul>
      </div>
    </div>
  </div>
</nav>
        </>
    )
};

export default NavBtns;